import { Theme } from "Components/Themes/themeInterfaces";

export interface PartnerState {
  readonly partnerId: "" | Partner;
  readonly brandingTheme: BrandingTheme;
  readonly agreementNumber?: number;
  readonly isUpdating: boolean;
  readonly updated: boolean;
  readonly error: string | null;
}

export interface BrandingTheme extends Theme {
  readonly id: Partner;
}

export enum Partner {
  AFAG = "afag",
  LEGEFORENINGEN = "legeforeningen",
  TANNLEGEFORENINGEN = "tannlegeforeningen",
  VETERINARENE = "veterinarene",
  ECONA = "econa",
  NATURVITERNE = "naturviterne",
  LEKTORLAGET = "lektorlaget",
  PSYKOLOGFORENINGEN = "psykologforeningen",
  SAMFUNNSVITERNE = "samfunnsviterne",
  SAMFUNNSOKONOMENE = "samfunnsokonomene",
  COOP = "coop",
  DANSKE_BANK = "danskebank",
  HUSEIERNE = "huseierne",
  STOREBRAND = "stb",
}

export const akademikernePartners = [
  Partner.AFAG,
  Partner.LEGEFORENINGEN,
  Partner.TANNLEGEFORENINGEN,
  Partner.VETERINARENE,
  Partner.ECONA,
  Partner.NATURVITERNE,
  Partner.LEKTORLAGET,
  Partner.PSYKOLOGFORENINGEN,
  Partner.SAMFUNNSVITERNE,
  Partner.SAMFUNNSOKONOMENE,
];

export interface PartnerPayload {
  partnerId: Partner | "";
  brandingTheme: Partner | "";
}

export type AkaCartPartnerTypes =
  | Partner.AFAG
  | Partner.LEGEFORENINGEN
  | Partner.TANNLEGEFORENINGEN
  | Partner.VETERINARENE
  | Partner.ECONA
  | Partner.NATURVITERNE
  | Partner.LEKTORLAGET
  | Partner.PSYKOLOGFORENINGEN
  | Partner.SAMFUNNSVITERNE
  | Partner.SAMFUNNSOKONOMENE;

export type CartPartnerTypes =
  | AkaCartPartnerTypes
  | Partner.COOP
  | Partner.DANSKE_BANK
  | Partner.HUSEIERNE
  | undefined;
